import { format, parseISO } from "date-fns";

const emptyString = "";
const doaValue = (value, specificFormat) => {
  if (!value || value === undefined || value === null) {
    return emptyString;
  }
  let trimmedValue;
  if (value instanceof Date) {
    trimmedValue = value.toISOString().trim();
  } else if (typeof value === "string") {
    trimmedValue = value.trim();
  } else {
    return emptyString;
  }

  if (trimmedValue === "") {
    return emptyString;
  }

  const date = parseISO(trimmedValue);
  return format(date, specificFormat);
};
const FormatISODate = (date, specificFormat = "M/d/yyyy") => {
  return doaValue(date, specificFormat);
};
export default FormatISODate;
